














import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import EmptyAccountPalce from "@/components/EmptyAccountPalce/EmptyAccountPalce.vue";
import ImgFetched from "@/components/ImgFetched/ImgFetched.vue";
@Component({
  components: { EmptyAccountPalce, ImgFetched }
})
export default class SelectUser extends Vue {
  @Prop()
  private userIcon: any;
  @Prop({ default: "" })
  private selectIcon!: string;

  @Emit("clickSelectUser")
  private clickSelectUser() {
    //
  }
}
